"use strict";
/**
 * @property {string}         templateId
 * @property {string}         title                 - template identifier
 * @property {string}         grade                 - template's grade identifier
 * @property {string}         module                - template's module identifier
 * @property {number}         score                 - template's score identifier
 * @property {number}         maxScore              - template's maximum score identifier
 * @property {number}         percentage            - template's score percentage identifier
 * @property {number}         scoreCore             - template's score core identifier
 * @property {number}         maxScoreCore          - template's maximum score core identifier
 * @property {number}         percentageCore        - template's percentage core identifier
 * @property {number}         schoolCount           - template's school count
 * @property {number}         gradeCount          - template's grade count
 * @property {number}         classCount            - template's class count
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminAssessmentList = void 0;
var AdminAssessmentList = /** @class */ (function () {
    function AdminAssessmentList(adminAssessmentList) {
        if (adminAssessmentList === void 0) { adminAssessmentList = {}; }
        Object.assign(this, adminAssessmentList);
    }
    return AdminAssessmentList;
}());
exports.AdminAssessmentList = AdminAssessmentList;
